import { useTranslation } from "@equiem/web-ng-lib";
import type { TagVariant } from "@equiem/react-end-user-ui";
import { OccurrenceSummaryFragmentFragment, ParticipationState } from "../../generated/gateway-client";

export interface RsvpTagProps {
  variant: TagVariant;
  label: string;
  showCheckIcon?: boolean;
  showSpotsOpenIcon?: boolean;
}

type Occurrence = Pick<OccurrenceSummaryFragmentFragment, "userState">;

export const useRsvpTagProps = (occurrence: Occurrence): RsvpTagProps | null => {
  const { t } = useTranslation();
  const rsvpOpenTag: RsvpTagProps = { variant: "primary", label: t("main.rsvpOpen") };

  switch (occurrence.userState) {
    case ParticipationState.ParticipationConfirmed:
      return { variant: "positive", label: t("main.going") };

    case ParticipationState.WaitlistedWithCapacity:
      return { variant: "primary", label: t("main.spotsOpen"), showSpotsOpenIcon: true };

    case ParticipationState.FullWaitlisted:
    case ParticipationState.FullWaitlistedSpotsClaimed:
      return { variant: "positive", label: t("main.onWaitlist"), showCheckIcon: true };

    case ParticipationState.FullCanWaitlist:
      return { variant: "warning", label: t("main.waitlistOpen") };

    case ParticipationState.OpenLimited:
    case ParticipationState.OpenUnlimited:
      return rsvpOpenTag;

    case ParticipationState.Closed:
    case ParticipationState.ParticipationDisabled:
      return null;

    default: {
      // Compile-time guard: a newly added ParticipationState must be handled above.
      const unhandled: never = occurrence.userState;

      if (typeof unhandled === "string") {
        return null;
      }

      return null;
    }
  }
};
